export const MY_ACCOUNT_LINK_HREF = '/my-account'
